import { useState } from "react";

import { Tune } from "@material-ui/icons";
import { Popover, Tooltip } from "antd";
import styled from "styled-components";

import { PdenSourceEnum } from "models/pdenDataSourceSetting";

import DateRangeSelect from "components/groupBy/DateRangeSelect";
import ForecastSourceSelect from "components/groupBy/ForecastSourceSelect";
import PdenSourceSelect from "components/groupBy/PdenSourceSelect";

interface DataSettingsButtonProps {
  initialState?: { selectedProperties: string[]; pdenSource: PdenSourceEnum };
}

export default function DataSettingsButton({ initialState }: DataSettingsButtonProps) {
  const [open, setOpen] = useState(false);

  const content = (
    <PopoverContent>
      <PopoverTitle>Performance Data Settings</PopoverTitle>
      <PdenSourceSelect
        showLabel={true}
        showGroup={true}
        isDataTable={true}
        initialState={initialState}
      />
      <ForecastSourceSelect
        showGroup={true}
        showLabel={true}
        alwaysShowForecastTrumping={true}
      />
      <DateRangeSelect showLabel={true} />
    </PopoverContent>
  );

  return (
    <Popover
      content={content}
      placement="bottomLeft"
      trigger="click"
      open={open}
      onOpenChange={setOpen}>
      <Tooltip title="Performance Data Settings" mouseEnterDelay={0.6}>
        <IconButton>
          <Tune fontSize="large" />
        </IconButton>
      </Tooltip>
    </Popover>
  );
}

const PopoverContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const PopoverTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  color: var(--color-text);
  padding-bottom: 4px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
`;

const IconButton = styled.button`
  width: 36px;
  height: 36px;
  display: grid;
  grid-template-columns: 36px max-content;
  align-items: center;
  justify-items: center;
  background: transparent;
  border: none;
  color: #a2aaad;
  font-weight: 500;
  padding: 0;
  margin: 0;
  transition: color 0.15s ease-out;
  overflow: hidden;
  pointer-events: all;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    color: var(--color-primary);
  }
`;
